<template>
  <span v-if="hasTranslation">
    <!--
      <v-textarea
                v-bind="$attrs"
                :modelValue="modelValue"
                :label="labelText"
                :hint="hintText"
                :persistent-hint="persistentHint"
                :active="active"
                :autofocus="autofocus"
                :bg-color="bgColor"
                :base-color="baseColor"
                :variant="variant"
                @input="$emit('update:modelValue', $event.target.value)"
                @update:focused="$emit('update:focused',true)"
              />
      -->
    <v-card>
      <div class="formheading">
        <I18nDiv :i18nkey="i18nlabel" class="fieldheading" />
        <I18nDiv :i18nkey="i18nhint" class="fieldhint" />
      </div>
      <v-card v-if="viewonly">
        <v-card-text v-html="startText" />
      </v-card>
      <RichEditor
        v-else
        v-bind="$attrs"
        height="var(--editor-height)"
        class="inlineEditor"
        ref="myCKEditor"
        v-model="editorText"
        :initial-text="startText"
        editor-type="full"
        @blur="onEditorBlur($event)"
        @focus="onEditorFocus($event)"
        @ready="onEditorReady($event)"
        @change="onTextChange($event)"
        @selected="onSelected($event)"
        @input="$emit('update:modelValue', $event)"
      />
    </v-card>
    <!--
    <v-card :text="editorText"/>
    <div v-html="editorText"/>
     height="var(--editor-height)"

              <v-text-field
    v-bind="$attrs"
    :modelValue="modelValue"
    @input="$emit('update:modelValue', $event.target.value)"
     />
     -->
  </span>
</template>

<script>
import adminStore from '@/stores/adminstore'
import { mapActions, mapState, mapGetters } from 'pinia'
import { defineModel } from 'vue'
import RichEditor from '../editor/RichEditor.vue'
import { HypTools } from '@/lib/tools.js'
const hypTools = new HypTools()

// import { defineAsyncComponent } from 'vue'

export default {
  name: 'I18nTextarea',
  components: { RichEditor },
  emits: ['update:modelValue', 'update:focused'],
  props: {
    modelValue: {},
    i18nlabel: {
      type: String,
      required: true
    },
    i18nhint: {
      type: String,
      required: false,
      default: ''
    },
    persistentHint: {
      type: Boolean,
      required: false,
      default: false
    },
    active: {
      type: Boolean,
      required: false,
      default: true
    },
    autofocus: {
      type: Boolean,
      required: false,
      default: false
    },
    bgColor: {
      type: String,
      required: false,
      default: 'var(--color-white)'
    },
    baseColor: {
      type: String,
      required: false,
      default: 'var(--color-white)'
    },
    variant: {
      type: String,
      required: false,
      default: 'solo'
    },
    viewonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      labelText: '',
      hintText: '',
      hasTranslation: false,
      inputValue: '', //defineModel(),
      value: '',
      editorText: '',
      startText: ''
    }
  },
  beforeMount() {
    //  console.log('i18nTextare GOT BEFORE MOUNT !')
  },
  mounted() {
    console.log('TEXT AREA GOT MOUNTED (%s)', this.modelValue)
    // console.log('Label (%s)', this.i18nlabel)
    // console.log('HING (%s)', this.i18nhint)
    this.geti18nTranslation(this.i18nlabel).then((result) => {
      // console.log('i18nTextare TRANSLATE TEXT (%s)', result)
      this.labelText = result
      this.geti18nTranslation(this.i18nhint).then((res2) => {
        this.hintText = res2
        this.hasTranslation = true
      })
    })
    this.editorText = hypTools.asString(this.modelValue)
    this.startText = hypTools.asString(this.modelValue)
  },
  methods: {
    ...mapActions(adminStore, ['geti18nTranslation']),
    ...mapGetters(adminStore, ['getTranslationMap']),
    setActiveContent() {
      console.log('set Active Content (%s)', this.editorText)
    },
    onEditorBlur(quill) {
      console.log('editor blur!', quill)
      this.$emit('update:focused', true)
      //      this.saveEditor()
    },
    onEditorFocus(quill) {
      //    console.log('editor focus!', quill)
      //   console.log(quill.getText());
    },
    onEditorReady(quill) {
      this.loadingData = false
      //     console.log('editor ready!', quill)
    },
    onEditorChange({ quill, html, text }) {
      //   console.log('editor change!', quill, html, text)
      this.allText = text
      this.content = html
      this.isSaved = false
    },
    onTextChange({ quill, html, text }) {
      // , source
      // console.log('on text change!')
      // console.log('SOURCE (%s)', source)
      // console.log('html (%s)', html)
      /* console.log(
        'editor is ready (%s), (%s)',
        this.editorIsReady,
        this.editorIsReady && html !== ''
      )
      */
      if (this.isDisabled()) {
        this.showAlert = true
      }
      if (this.editorIsReady && html !== '') {
        this.allText = text
        this.content = html
        this.information.rawText = text
        //        this.information.htmlText = html // htmlText is Identifier for bucket
        this.information.information_content = html
        this.saveAssignment(this.information)
        this.numkeystrokes++
        if (this.numkeystrokes > 47) {
          this.numkeystrokes = 0
          this.saveEditor()
        }
        //        console.log('********** I N F O R M A T I O N  __4__ ********')
        //        console.log(this.information)
        this.isSaved = false
      }
    },
    onSelected({ range, quill }) {
      //   console.log('on Selected !', range, quill)
      this.cursorPosition = range.index
      if (range.length == 0) {
        // console.log('User cursor is on', range.index)
      } else {
        var text = quill.getText(range.index, range.length)
        console.log('User has highlighted (%s)', text)
        console.log(range)
      }
      console.log('Cursor not in the editor')
    },
    isDisabled() {
      return false
    }
  }
}
</script>

<style scoped>
.inlineEditor {
  margin: 0.2vh 1vw;
  border: solid;
  border-width: 0.05vw;
  border-color: var(--color-border);
  border-radius: 0.2vw;
  overflow: hidden;
}

.formheading {
  background-color: var(--color-brand-500);
}

.fieldheading {
  font-size: 1.1rem;
  font-weight: 500;
  padding-left: 1.2vw;
  padding-bottom: 0vh;
  margin-bottom: 0vh;
}

.fieldhint {
  font-size: 0.8rem;
  font-weight: 300;
  padding-left: 3vw;
  padding-right: 2vw;
  padding-bottom: 0.1vh;
}
</style>
